//-----------------------------------------------------------------------------
//  Copyright (c) 2019 by Dell Inc.
//
// All rights reserved.  This software may not be copied, disclosed,
// transferred, or used except in accordance with a license granted
// by Dell Inc.  This software embodies proprietary information
// and trade secrets of Dell Inc.
//
//-----------------------------------------------------------------------------

import React from 'react';
import styled from '@emotion/styled';
import WarningIcon from '../icons/WarningIcon';

const Empty = styled.div`
  display: flex;
  flex-direction: column;
  color: #aaaaaa;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

const Title = styled.h2`
  margin-top: 0.8rem;
  font-weight: 500;
  font-size: 1.6rem;
  text-align: center;
`;

const WarningContainer = styled.p`
  text-align: center;
  height: 2rem;
  margin: 0px;
`;

export function TableErrorOverlay() {
  return (
    <Empty>
      <WarningContainer data-testid={'table-error-overlay'}>
        <WarningIcon />
      </WarningContainer>
      <Title data-testid="error-message">
        An error occurred processing this table. <br />
        Please&nbsp;
        <a
          target="_blank"
          rel="noreferrer noopener"
          href="https://support.liveoptics.com/hc/en-us/requests/new"
        >
          open a support ticket
        </a>{' '}
        to have this issued investigated.
      </Title>
    </Empty>
  );
}
